export default (): Record<string, string> => {
  const ubaScript: HTMLScriptElement = document.currentScript as HTMLScriptElement || document.querySelector('#uba-sdk') || document.querySelector('script[data-uba-params]');
  let conf: Record<string, string> = {};
  if(ubaScript) {
    const src = ubaScript.src || '';
    const ubaParams = ubaScript.getAttribute('data-uba-params');
    const setConf = (params: string) => {
      params.split('&').forEach(str => {
        const kv = str.split('=');
        if(kv.length === 2) {
          conf[kv[0]] = kv[1];
        }
      });
    };
    conf.jsPath = src.replace(/uba-init.*/, '');
    if (ubaParams) {
      setConf(ubaParams);
    }
    if (/.+\?/.test(src)) {
      const urlParams = src.replace(/.+\?/, '');
      setConf(urlParams);
    }
  }
  if(conf.reportPath) {
    conf.reportHost = conf.reportPath;
  }
  if(conf.autoCollect && conf.autoCollect !== 'true' && conf.autoCollect !== '1') {
    conf.autoCollect = '0';
  }
  return conf;
}
